import { AIResultDisplayModel, AIResultViewModel, SegmentedResultViewModel } from './AIResultMapper'
import { getTotalSegmentations } from './OndemandAIExecution'
import { AIResultSegmentationHeader } from './AIResultsViews'
import React, { ComponentType } from 'react'
import { ActionableAIResultProps, AIExecutionType } from './models'
import { AIFeature } from '@zocks-communications/client-sdk-js'

export const SegmentedAIResultView: React.FC<{
  aiFeature: AIFeature
  aiResult: AIResultViewModel
  ActionableAIResultElement: ComponentType<ActionableAIResultProps>
  onDismissAIResult?: (aiResultDisplay: AIResultDisplayModel) => void
  onAIResultChanged?: (changedResult: string, changedAIResultDisplayId: string) => Promise<void>
  executionType?: AIExecutionType
  onSelectAIResult?: (aiResult: AIResultDisplayModel) => void
}> = ({ aiFeature, aiResult, ActionableAIResultElement, onDismissAIResult, onAIResultChanged, executionType, onSelectAIResult }) => {
  return (
    <>
      {(aiResult.result as SegmentedResultViewModel).segmentResults.map((segmentResult) => {
        const totalSegmentations = getTotalSegmentations(aiResult)
        return (
          <div className='ai-result-segmentation-group' key={`${aiResult.id}-${segmentResult.metadata.segmentIdx}`}>
            <AIResultSegmentationHeader metadata={segmentResult.metadata} totalSegmentations={totalSegmentations} />
            {segmentResult.results.map((individualAIResult) => {
              return individualAIResult.result.map((r) => {
                return (
                  <ActionableAIResultElement
                    aiFeature={aiFeature}
                    aiResult={aiResult}
                    key={r.displayId}
                    aiResultDisplay={r}
                    onDismissAIResult={onDismissAIResult}
                    totalSegmentations={totalSegmentations}
                    onAIResultChanged={onAIResultChanged}
                    executionType={executionType}
                    onSelectAIResult={onSelectAIResult}
                  />
                )
              })
            })}
          </div>
        )
      })}
    </>
  )
}
